import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "text-xs text-muted-foreground" }

import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAuthStore } from '@/stores/auth'

import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Loader2, Send } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'CommentForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const { t } = useI18n()
const authStore = useAuthStore()

const content = ref('')
const isInternal = ref(false)
const isSubmitting = ref(false)

const isAdmin = computed(() => authStore.user?.role === 'admin' || authStore.user?.role === 'operator')

const canSubmit = computed(() => content.value.trim().length > 0 && !isSubmitting.value && !props.isLoading)

const handleSubmit = async () => {
  if (!canSubmit.value) return

  isSubmitting.value = true
  try {
    emit('submit', content.value.trim(), isInternal.value)
    content.value = ''
    isInternal.value = false
  } finally {
    isSubmitting.value = false
  }
}

const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter' && (event.metaKey || event.ctrlKey)) {
    handleSubmit()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Textarea), {
      modelValue: content.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
      placeholder: _unref(t)('comments.placeholder'),
      class: "min-h-[80px] resize-none",
      disabled: isSubmitting.value || __props.isLoading,
      onKeydown: handleKeydown
    }, null, 8, ["modelValue", "placeholder", "disabled"]),
    _createElementVNode("div", _hoisted_2, [
      (isAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_unref(Checkbox), {
              id: "isInternal",
              modelValue: isInternal.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isInternal).value = $event)),
              disabled: isSubmitting.value || __props.isLoading
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_unref(Label), {
              for: "isInternal",
              class: "text-sm text-muted-foreground cursor-pointer"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('comments.internalComment')), 1)
              ]),
              _: 1
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createVNode(_unref(Button), {
        onClick: handleSubmit,
        disabled: !canSubmit.value,
        size: "sm"
      }, {
        default: _withCtx(() => [
          (isSubmitting.value)
            ? (_openBlock(), _createBlock(_unref(Loader2), {
                key: 0,
                class: "mr-2 h-4 w-4 animate-spin"
              }))
            : (_openBlock(), _createBlock(_unref(Send), {
                key: 1,
                class: "mr-2 h-4 w-4"
              })),
          _createTextVNode(" " + _toDisplayString(_unref(t)('comments.addComment')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('comments.shortcut')), 1)
  ]))
}
}

})